import { NgModule } from '@angular/core';

import { DetectionBboxPipe } from './detection-bbox.pipe';

@NgModule({
  declarations: [DetectionBboxPipe],
  exports: [DetectionBboxPipe],
})
export class DetectionBboxPipeModule {}
